import "../../App.css";
import "./Header.css";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { configShop } from '../../states/configShop';

export const Header1 = (props) => {
  const { propiedadesCompany } = props;
  const { dataConfig } = configShop();
  const [listaProductosCarrito, setListaProductosCarrito] = useState();
  var totalCantidadCarrito = 0;
  useEffect(() => {
    const informacionLocalStorage = localStorage.getItem(
      "infoProductoSeleccionado"
    );
    if (
      informacionLocalStorage !== undefined &&
      informacionLocalStorage !== null
    ) {
      let parsedRespuesta = JSON.parse(informacionLocalStorage); // JSON.parse convierte la información de string a un objeto de javascript.

      setListaProductosCarrito(parsedRespuesta);
    }
  }, []);
  if (listaProductosCarrito !== undefined) {
    listaProductosCarrito.map((item) => {
      totalCantidadCarrito += item.cantidadProducto;
    });
  }
  return (
    <div className="header1">
      <div className="left">
        <Link to="javascript:void(0)" onClick={() => window.history.back()}>
          <FaArrowLeft color={dataConfig?.page_menu?.button?.color ?? "#000"} size={24} />
        </Link>
      </div>
      <div className="center">
        <img
          src={propiedadesCompany?.page_menu?.logo_image}
          className="header-company-logo"
          alt="logo"
        />
      </div>
      <div className="right"></div>
    </div>
  );
};

export default Header1;
